// src/components/Navbar/Navbar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <NavLink to="/" className="nav-logo" onClick={() => setOpen(false)}>
          <img
            src="/images/logoblessing.jpeg"
            alt="The Blessing Interiors - Interior Designers in Coimbatore"
            className="nav-logo-img"
          />
        </NavLink>

        {/* <NavLink to="/" className="nav-logo" onClick={() => setOpen(false)}>
          The Blessing <span>Interiors</span>
        </NavLink> */}


        {/* DESKTOP LINKS */}
        <nav className="nav-links">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/works">Our Works</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          className="nav-menu-btn"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          {open ? "✖" : "☰"}
        </button>
      </div>

      {/* MOBILE DROPDOWN */}
      {open && (
        <div className="mobile-menu">
          <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/works" onClick={() => setOpen(false)}>Our Works</NavLink>
          <NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        </div>
      )}
    </header>
  );
}
